import { bestFinds, priceComparison } from '@/mocks/products';

export default function ProductTable() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Best AllChinaBuy Finds
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            Handpicked products from trusted sellers — updated every week
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {bestFinds.map((item) => (
            <div
              key={item.product}
              className="bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all group"
            >
              <div className="aspect-square overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.product}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-3">{item.product}</h3>
                <div className="grid grid-cols-3 gap-2 text-center">
                  <div className="bg-primary-50 rounded-lg py-2 px-1">
                    <p className="text-xs text-foreground-500">Price</p>
                    <p className="text-sm font-bold text-primary-700">{item.price}</p>
                  </div>
                  <div className="bg-accent-50 rounded-lg py-2 px-1">
                    <p className="text-xs text-foreground-500">Quality</p>
                    <p className="text-sm font-bold text-accent-700">{item.quality}</p>
                  </div>
                  <div className="bg-secondary-50 rounded-lg py-2 px-1">
                    <p className="text-xs text-foreground-500">Seller</p>
                    <p className="text-sm font-bold text-secondary-700">{item.seller}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
            Price Comparison — Retail vs. AllChinaBuy Spreadsheet
          </h3>
          <div className="overflow-x-auto rounded-xl border border-background-200">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-100">
                  <th className="text-left px-5 py-3.5 font-semibold text-foreground-800">Product</th>
                  <th className="text-center px-5 py-3.5 font-semibold text-foreground-800">Retail Price</th>
                  <th className="text-center px-5 py-3.5 font-semibold text-primary-700">Spreadsheet Price</th>
                  <th className="text-center px-5 py-3.5 font-semibold text-accent-700">You Save</th>
                </tr>
              </thead>
              <tbody>
                {priceComparison.map((row, i) => (
                  <tr key={row.product} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                    <td className="px-5 py-3.5 font-medium text-foreground-900">{row.product}</td>
                    <td className="text-center px-5 py-3.5 text-foreground-600">{row.officialPrice}</td>
                    <td className="text-center px-5 py-3.5 font-semibold text-primary-700">{row.spreadsheetPrice}</td>
                    <td className="text-center px-5 py-3.5">
                      <span className="inline-flex items-center px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-bold">
                        {row.savings}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}